import React from "react";
import "./TextInput.css";
import { useTranslation } from "react-i18next";

const TextInput = ({
  name,
  openMapHandler,
  maxLength,
  errors,
  register,
  label,
  type,
  mandatory,
  value,
  disabled = false,
  style,
}) => {
  const { onChange, ...registerParams } = register(name);
  const { t } = useTranslation();

  // If maxLength is null or undefined, apply no limit (undefined means no maxLength attribute);
  // const effectiveMaxLength = maxLength === null ? maxLength = undefined : maxLength = 200;

  const effectiveMaxLength = maxLength
    ? parseInt(maxLength)
    : maxLength === null
    ? undefined
    : 200;

  return (
    <div className="input_text-form">
      <div className="input_text-form flexbox">
        <label>
          {t(label)}
          {mandatory && <span className="asterisk">*</span>}
        </label>
        {name === "latitude" && (
          <span className="facility_maplink--position" onClick={openMapHandler}>
            {t("locateonmap")}
          </span>
        )}
      </div>
      <input
        maxLength={effectiveMaxLength}
        autoComplete="off"
        className={`form-control branch-input-form-control  ${
          errors[name]
            ? "error__border--color"
            : "form-control branch-input-form-control"
        }`}
        type={type}
        disabled={disabled}
        onChange={(event) => {
          onChange(event);
        }}
        {...registerParams}
        style={style}
      />
      <div className="error__message">{errors[name]?.message}</div>
    </div>
  );
};

export default TextInput;
